export default {
	title: "Watch",
	url: "watch",
	subtitle: "Strategic watch report generated through anonymised research: the project subject is neutralised before any call to public sources. The report covers the macro context (PESTEL), sector context (Porter's 5 forces) and internal context, with strong and weak signals.",
	current: "Current report",
	archive: "Archives",
	context_tab: "Context",
	empty: "No watch report for this project yet.",
	generated_on: "Issued on",
	impact_tab_tooltip: "Analysis of the impact on your project and scenario generation",
	impact_tab: "Project impact",
	impact_description: "Generate a strategic scenario based on the trends identified in this watch report.",
	actions: {
		generate: "Generate a report",
		generate_new: "Generate a new report",
		generating: "Generating… (about ten minutes)",
		retry: "Retry",
		print: "Print",
		delete: "Delete this report",
		delete_confirm: "Permanently delete this report?",
		generate_scenario: "Generate a scenario from this report"
	},
	steps: {
		anonymizing: "Anonymising the subject",
		researching: "Research and writing",
		done: "Report available",
		elapsed: "for {{minutes}} min"
	},
	messages: {
		failed: "Generation failed",
		neutral_subject: "Anonymised subject sent",
		confirm_title: "Launch an anonymised watch?",
		confirm_body: "The project subject will be anonymised before any research on public sources. Generating the report takes about ten minutes.",
		context_label: "Specific angles to cover (optional)",
		context_placeholder: "E.g.: impact on our European partners, regulatory changes…",
		context_hint: "This text is also anonymised before being sent.",
		attachments_label: "Internal project documents (optional)",
		attachments_hint: "Documents added here are analysed privately by AI, without leaving your AWS account."
	}
};
